import { FC, useCallback, useMemo } from "react";
import { Tree } from "types/tree.type";

type PropsType = {
  selectedBranch?: Tree;
  selectedOrgs: Tree[];
  setSelectedOrgs: (trees: Tree[]) => void;
};

type ItemPropsType = {
  org: Tree;
  selectedOrgs: Tree[];
  setSelectedOrgs: (trees: Tree[]) => void;
};

const OrganizationItem: FC<ItemPropsType> = ({
  org,
  selectedOrgs,
  setSelectedOrgs,
}) => {
  const selected = useMemo(
    () => selectedOrgs.map((org) => org.id).includes(org.id),
    [selectedOrgs, org],
  );

  const onSelect = useCallback(() => {
    let orgs = selectedOrgs;
    if (selected) {
      orgs = orgs.filter((o) => o.id !== org.id);
    } else {
      orgs = orgs.concat(org);
    }
    setSelectedOrgs(orgs);
  }, [selectedOrgs, setSelectedOrgs, selected, org]);

  return (
    <div
      onClick={onSelect}
      className={selected ? "org-item selected" : "org-item"}
      key={org.id}
    >
      {org.name || org?.person?.name}
    </div>
  );
};

const OrganizationList: FC<PropsType> = ({ selectedBranch, ...props }) => {
  return (
    <div className="organization-list">
      {selectedBranch && <OrganizationItem org={selectedBranch} {...props} />}
    </div>
  );
};

export default OrganizationList;
